import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setIsLoggedIn } from "./redux/slices/isLoggedInSlice";
import { setAuthLoading } from "./redux/slices/authLoadingSlice";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PublicRoute from './components/PublicRoute/PublicRoute';
import PrivateRoute from './components/PrivateRoute/PrivateRoute'
import publicApi from "./apis/publicApi";
import { clearRole, setRole } from "./redux/slices/roleSlice";
import { clearPermissions } from "./redux/slices/permissionsSlice";
import { setPermissions } from "./redux/slices/permissionsSlice";
// import Topbar from './components/Topbar/Topbar'
import Navbar from './components/Navbar/Navbar'
import GeoLocations from "./pages/GeoLocations/GeoLocations";
import "./index.css";
import Login from "./pages/Login/Login";
import Dashboard from "./pages/Dashboard/Dashboard";
// import Dashboard1 from "./pages/Dashboard1/Dashboard1";
import Layout from "./components/Layout/Layout";
import AdministrativeUnits from "./pages/AdministrativeUnits/AdministrativeUnits";
import EconomicSegment from "./pages/EconomicSegment/EconomicSegment";
import FunctionalSegment from "./pages/FunctionalSegment/FunctionalSegment";
import ProgrammeSegment from "./pages/ProgrammeSegment/ProgrammeSegment";
import FundSegment from "./pages/FundSegment/FundSegment";
import UserList from "./pages/UserList/UserList";
import AdminUser from "./pages/AdminUser/AdminUser";
import AdminUserEdit from "./pages/AdminUserEdit/AdminUserEdit";
import BudgetCreate from "./pages/BudgetCreate/BudgetCreate";
import LGABudgetCreate from "./pages/LGABudgetCreate/LGABudgetCreate";
import LGABudgetList from "./pages/LGABudgetList/LGABudgetList";
import LGABudgetDetail from "./pages/LGABudgetDetail/LGABudgetDetail";
import LGABudgetEdit from "./pages/LGABudgetEdit/LGABudgetEdit";
import BudgetLineCreate from "./pages/BudgetLineCreate/BudgetLineCreate";
import BudgetLines from "./pages/BudgetLines/BudgetLines";
import BudgetLineDetail from "./pages/BudgetLineDetail/BudgetLineDetail";
import BudgetLineEdit from "./pages/BudgetLineEdit/BudgetLineEdit";
import BudgetLineBulkCreate from "./pages/BudgetLineBulkCreate/BudgetLineBulkCreate";
import BudgetBudgetLines from "./pages/BudgetBudgetLines/BudgetBudgetLines";
import Transactions from "./pages/Transactions/Transactions";
import TransactionsCreate from "./pages/TransactionsCreate/TransactionsCreate";
import BudgetLineTransactions from "./pages/BudgetLineTransactions/BudgetLineTransactions";
import TransactionDetail from "./pages/TransactionDetail/TransactionDetail";
import Report from "./pages/Report/Report";
import RolesCreate from "./pages/RolesCreate/RolesCreate";
import Roles from "./pages/Roles/Roles";
import RoleDetail from "./pages/RoleDetail/RoleDetail";
import RoleEdit from "./pages/RoleEdit/RoleEdit";
import AdminUserCreate from "./pages/AdminUserCreate/AdminUserCreate";
import CompleteRegistration from "./pages/CompleteRegistration/CompleteRegistration";
import AdministrativeUnitsCreate from "./pages/AdministrativeUnitsCreate/AdministrativeUnitsCreate";
import EconomicSegmentsCreate from "./pages/EconomicSegmentsCreate/EconomicSegmentsCreate";
import FunctionalSegmentsCreate from "./pages/FunctionalSegmentsCreate/FunctionalSegmentsCreate";
import FundSegmentsCreate from "./pages/FundSegmentsCreate/FundSegmentsCreate";
import ProgrammeSegmentCreate from "./pages/ProgrammeSegmentsCreate/ProgrammeSegmentsCreate";
import Budgets from "./pages/Budgets/Budgets";
import BudgetDetail from "./pages/BudgetDetail/BudgetDetail";
import BudgetsEdit from "./pages/BudgetsEdit/BudgetsEdit";
import WardsCreate from "./pages/WardsCreate/WardsCreate";
import ResetPassword from "./pages/ResetPassword/ResetPassword";

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    const checkSession = async () => {
      try {
        const { data } = await publicApi.post("/api/auth/refresh"); // refresh token
        dispatch(setIsLoggedIn(true));
        dispatch(setRole(data.role));
        dispatch(setPermissions(data.role.permissions));
      } catch {
        dispatch(setIsLoggedIn(false));
        dispatch(clearRole());
        dispatch(clearPermissions());
      } finally {
        dispatch(setAuthLoading(false));
      }
    };

    checkSession();
  }, [dispatch]);

  return (
    <Router>
      {/* <Topbar /> */}
      <Navbar />

      <div className="app-routes">
        <Routes>

          {/* Public Route */}
          <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/reset-password" element={<PublicRoute><ResetPassword /></PublicRoute>} />
          <Route path="/complete-registration" element={<PublicRoute><CompleteRegistration /></PublicRoute>} />

          {/* Layout Wrapper Route */}
          <Route element={<Layout />}>
            <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
            {/* <Route path="/dashboard1" element={<PrivateRoute><Dashboard1 /></PrivateRoute>} /> */}


            <Route path="/roles/create" element={<PrivateRoute><RolesCreate /></PrivateRoute>} />
            <Route path="/roles" element={<PrivateRoute><Roles /></PrivateRoute>} />
            <Route path="/roles/detail" element={<PrivateRoute><RoleDetail /></PrivateRoute>} />
            <Route path="/roles/edit" element={<PrivateRoute><RoleEdit /></PrivateRoute>} />


            <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />


            <Route path="/admin/users/create" element={<PrivateRoute><AdminUserCreate /></PrivateRoute>} />
            <Route path="/admin/users" element={<PrivateRoute><UserList /></PrivateRoute>} />
            <Route path="/admin/user" element={<PrivateRoute><AdminUser /></PrivateRoute>} />
            <Route path="/admin/users/edit" element={<PrivateRoute><AdminUserEdit /></PrivateRoute>} />

            <Route path="/administrative-units/create" element={<PrivateRoute><AdministrativeUnitsCreate /></PrivateRoute>} />
            <Route path="/economic-segments/create" element={<PrivateRoute><EconomicSegmentsCreate /></PrivateRoute>} />
            <Route path="/functional-segments/create" element={<PrivateRoute><FunctionalSegmentsCreate /></PrivateRoute>} />
            <Route path="/fund-segments/create" element={<PrivateRoute><FundSegmentsCreate /></PrivateRoute>} />
            <Route path="/programme-segments/create" element={<PrivateRoute><ProgrammeSegmentCreate /></PrivateRoute>} />

            <Route path="/geo-locations" element={<PrivateRoute><GeoLocations /></PrivateRoute>} />
            <Route path="/wards/create" element={<PrivateRoute><WardsCreate /></PrivateRoute>} />

            <Route path="/administrative-units" element={<PrivateRoute><AdministrativeUnits /></PrivateRoute>} />
            <Route path="/economic-segment" element={<PrivateRoute><EconomicSegment /></PrivateRoute>} />
            <Route path="/functional-segment" element={<PrivateRoute><FunctionalSegment /></PrivateRoute>} />
            <Route path="/programme-segment" element={<PrivateRoute><ProgrammeSegment /></PrivateRoute>} />
            <Route path="/fund-segment" element={<PrivateRoute><FundSegment /></PrivateRoute>} />


            <Route path="/budgets/create" element={<PrivateRoute><BudgetCreate /></PrivateRoute>} />
            <Route path="/budgets/detail" element={<PrivateRoute><BudgetDetail /></PrivateRoute>} />
            <Route path="/budgets/edit" element={<PrivateRoute><BudgetsEdit /></PrivateRoute>} />


            <Route path="/lga/budgets/create" element={<PrivateRoute><LGABudgetCreate /></PrivateRoute>} />
            <Route path="/lga/budgets" element={<PrivateRoute><LGABudgetList /></PrivateRoute>} />
            <Route path="/lga/budget/" element={<PrivateRoute><LGABudgetDetail /></PrivateRoute>} />
            <Route path="/lga/budget/edit" element={<PrivateRoute><LGABudgetEdit /></PrivateRoute>} />


            <Route path="/budget-lines/create" element={<PrivateRoute><BudgetLineCreate /></PrivateRoute>} />
            <Route path="/budget-lines/bulk-create" element={<PrivateRoute><BudgetLineBulkCreate /></PrivateRoute>} />
            <Route path="/budget-lines" element={<PrivateRoute><BudgetLines /></PrivateRoute>} />
            <Route path="/budgets" element={<PrivateRoute><Budgets /></PrivateRoute>} />
            <Route path="/budget/budget-lines" element={<PrivateRoute><BudgetBudgetLines /></PrivateRoute>} />
            <Route path="/budget-lines/detail" element={<PrivateRoute><BudgetLineDetail /></PrivateRoute>} />
            <Route path="/budget-lines/edit" element={<PrivateRoute><BudgetLineEdit /></PrivateRoute>} />


            <Route path="/transactions" element={<PrivateRoute><Transactions /></PrivateRoute>} />
            <Route path="/budget-line/transactions" element={<PrivateRoute><BudgetLineTransactions /></PrivateRoute>} />
            <Route path="/transactions/detail" element={<PrivateRoute><TransactionDetail /></PrivateRoute>} />
            <Route path="/transactions/create" element={<PrivateRoute><TransactionsCreate /></PrivateRoute>} />


            <Route path="/reports" element={<PrivateRoute><Report /></PrivateRoute>} />
          </Route>

        </Routes>
      </div>
    </Router>
  );
}

export default App;